(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-founder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (section.hasAttribute('data-hw-ready')) return;
      section.setAttribute('data-hw-ready', '');
      const track = section.querySelector('[data-hw-track]');
      if (!track) return;
      const step = () => {
        const item = track.querySelector('.hw-founder__milestone');
        return item ? item.getBoundingClientRect().width + 16 : 260;
      };
      section.querySelector('[data-hw-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
      section.querySelector('[data-hw-next]')?.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
    };
    const scan = () => document.querySelectorAll('[data-hw-founder]').forEach(init);
    scan();
    document.addEventListener('shopify:section:load', scan);
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
  const hwReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initHero = (hero) => {
    if (hero.hasAttribute('data-hw-ready')) return;
    hero.setAttribute('data-hw-ready', '');
    const stage = hero.querySelector('[data-hw-stage]');
    const inner = stage && stage.querySelector('.hw-hero__stage-inner');
    const bottleImg = hero.querySelector('.hw-hero__bottle-img');
    const shine = hero.querySelector('.hw-hero__bottle-shine');

    if (bottleImg && shine) {
      const applyMask = () => shine.style.setProperty('--hw-bottle-mask', `url("${bottleImg.currentSrc || bottleImg.src}")`);
      bottleImg.complete ? applyMask() : bottleImg.addEventListener('load', applyMask, { once: true });
    }

    if (!inner || hwReduceMotion) return;

    let raf = null;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    const tick = () => {
      currentX += (targetX - currentX) * 0.08;
      currentY += (targetY - currentY) * 0.08;
      inner.style.setProperty('--hw-rx', `${currentY.toFixed(2)}deg`);
      inner.style.setProperty('--hw-ry', `${currentX.toFixed(2)}deg`);
      if (Math.abs(targetX - currentX) > 0.05 || Math.abs(targetY - currentY) > 0.05) {
        raf = requestAnimationFrame(tick);
      } else {
        raf = null;
      }
    };

    const schedule = () => {
      if (!raf) raf = requestAnimationFrame(tick);
    };

    const onMove = (event) => {
      const rect = hero.getBoundingClientRect();
      const nx = (event.clientX - rect.left) / rect.width - 0.5;
      const ny = (event.clientY - rect.top) / rect.height - 0.5;
      targetX = nx * 22;
      targetY = -ny * 16;
      schedule();
    };

    const onLeave = () => {
      targetX = 0;
      targetY = 0;
      schedule();
    };

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      hero.addEventListener('pointermove', onMove, { passive: true });
      hero.addEventListener('pointerleave', onLeave, { passive: true });
    }

    let lastScroll = 0;
    const onScroll = () => {
      const rect = hero.getBoundingClientRect();
      const progress = Math.min(Math.max(-rect.top / Math.max(rect.height, 1), 0), 1);
      if (Math.abs(progress - lastScroll) < 0.002) return;
      lastScroll = progress;
      stage.style.setProperty('transform', `translateY(${progress * 80}px) scale(${1 - progress * 0.12})`);
      stage.style.setProperty('opacity', `${1 - progress * 0.6}`);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };
  const scan = () => document.querySelectorAll('[data-hw-hero]').forEach(initHero);
  scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-pillars"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (section.hasAttribute('data-hw-ready')) return;
      section.setAttribute('data-hw-ready', '');
      const cards = [...section.querySelectorAll('[data-hw-card]')];
      if (!cards.length) return;
      const autoplay = section.dataset.hwAutoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let timer = null;
      let userTouched = false;

      const activate = (card) => {
        cards.forEach((c) => c.classList.toggle('is-active', c === card));
      };

      const next = () => {
        const i = cards.findIndex((c) => c.classList.contains('is-active'));
        activate(cards[(i + 1) % cards.length]);
      };

      const stop = () => {
        if (timer) clearInterval(timer);
        timer = null;
      };

      const start = () => {
        if (!autoplay || userTouched || timer) return;
        timer = setInterval(next, 5000);
      };

      cards.forEach((card) => {
        const open = () => {
          userTouched = true;
          stop();
          activate(card);
        };
        card.addEventListener('mouseenter', () => {
          if (window.matchMedia('(hover: hover)').matches) {
            stop();
            activate(card);
          }
        });
        card.addEventListener('click', (e) => {
          if (e.target.closest('[data-hw-herb], a')) return;
          open();
        });
        card.addEventListener('focus', open);
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open();
          }
        });

        const layers = card.querySelectorAll('[data-hw-layer]');
        const descs = card.querySelectorAll('[data-hw-herb-desc]');
        card.querySelectorAll('[data-hw-herb]').forEach((btn) => {
          const pick = () => {
            userTouched = true;
            stop();
            const idx = btn.dataset.hwHerb;
            card.querySelectorAll('[data-hw-herb]').forEach((b) => {
              const on = b === btn;
              b.classList.toggle('is-current', on);
              b.setAttribute('aria-selected', on ? 'true' : 'false');
            });
            layers.forEach((l) => l.classList.toggle('is-current', l.dataset.hwLayer === idx));
            descs.forEach((d) => d.classList.toggle('is-current', d.dataset.hwHerbDesc === idx));
          };
          btn.addEventListener('click', pick);
          btn.addEventListener('mouseenter', () => {
            if (window.matchMedia('(hover: hover)').matches) pick();
          });
        });
      });

      section.addEventListener('mouseleave', () => {
        if (!userTouched) start();
      });

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? start() : stop()));
      }, { threshold: 0.3 });
      io.observe(section);
    };
    const scan = () => document.querySelectorAll('[data-hw-pillars]').forEach(init);
    scan();
    document.addEventListener('shopify:section:load', scan);
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SUBSCRIBED = 'hw-subscribed';
    const SESSION_SHOWN = 'hw-popup-shown';
    const store = {
      get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} },
      sget: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
      sset: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} },
    };
    const isSubscribed = () => store.get(SUBSCRIBED) === '1';
    const anyOpen = () => !!document.querySelector('[data-hw-popup]:not([hidden])');

    const init = (popup) => {
      if (popup.hasAttribute('data-hw-ready')) return;
      popup.setAttribute('data-hw-ready', '');
      const key = popup.dataset.hwPopupKey;
      const trigger = popup.dataset.hwPopupTrigger || 'delay';
      const days = parseInt(popup.dataset.hwPopupDays, 10) || 7;
      const delay = (parseInt(popup.dataset.hwPopupDelay, 10) || 6) * 1000;
      const scrollPct = parseInt(popup.dataset.hwPopupScroll, 10) || 60;
      const design = popup.hasAttribute('data-hw-popup-design');
      const homeOnly = popup.dataset.hwPopupHomeOnly === 'true';
      const isHome = popup.dataset.hwPopupIsHome === 'true';
      const posted = popup.querySelector('[data-hw-popup-success]');
      const teaser = document.querySelector(`[data-hw-teaser-for="${key}"]`);
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      const dismissed = () => {
        const until = parseInt(store.get(key), 10);
        return until && until > Date.now();
      };
      const remember = () => store.set(key, String(Date.now() + days * 86400000));
      const showTeaser = () => {
        if (teaser && !isSubscribed()) teaser.hidden = false;
      };
      const open = () => {
        if (anyOpen() || isSubscribed()) return;
        popup.hidden = false;
        store.sset(SESSION_SHOWN, '1');
        if (teaser) teaser.hidden = true;
        const input = popup.querySelector('input[type="email"]');
        if (input) setTimeout(() => input.focus(), 300);
      };
      const close = () => {
        popup.hidden = true;
        remember();
        showTeaser();
      };

      popup.querySelectorAll('[data-hw-popup-close]').forEach((el) => el.addEventListener('click', close));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !popup.hidden) close();
      });
      popup.querySelector('form')?.addEventListener('submit', () => {
        remember();
        store.set(SUBSCRIBED, '1');
      });
      teaser?.addEventListener('click', () => {
        popup.hidden = false;
        teaser.hidden = true;
        const input = popup.querySelector('input[type="email"]');
        if (input) setTimeout(() => input.focus(), 300);
      });

      if (posted) {
        store.set(SUBSCRIBED, '1');
        popup.hidden = false;
        return;
      }
      if (design) return;
      if (isSubscribed()) return;
      if (homeOnly && !isHome) return;
      if (dismissed()) {
        showTeaser();
        return;
      }
      const alreadyThisSession = store.sget(SESSION_SHOWN) === '1';

      if (trigger === 'delay') {
        if (alreadyThisSession) { showTeaser(); return; }
        setTimeout(open, delay);
      } else if (trigger === 'scroll') {
        const onScroll = () => {
          const doc = document.documentElement;
          const pct = ((window.scrollY + window.innerHeight) / Math.max(doc.scrollHeight, 1)) * 100;
          if (pct >= scrollPct) {
            window.removeEventListener('scroll', onScroll);
            open();
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      } else if (trigger === 'exit') {
        if (canHover) {
          const onLeave = (e) => {
            if (e.clientY <= 0) {
              document.removeEventListener('mouseleave', onLeave);
              open();
            }
          };
          setTimeout(() => document.addEventListener('mouseleave', onLeave), 5000);
        } else {
          let last = window.scrollY;
          let armed = false;
          const onScroll = () => {
            const y = window.scrollY;
            if (y > 800) armed = true;
            if (armed && y < last - 400) {
              window.removeEventListener('scroll', onScroll);
              open();
            }
            last = y;
          };
          window.addEventListener('scroll', onScroll, { passive: true });
        }
      }
    };
    const scan = () => document.querySelectorAll('[data-hw-popup]').forEach(init);
    scan();
    document.addEventListener('shopify:section:load', scan);
    document.addEventListener('shopify:section:select', (e) => {
      const popup = e.target.querySelector('[data-hw-popup]');
      if (popup) popup.hidden = false;
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      const popup = e.target.querySelector('[data-hw-popup]');
      if (popup) popup.hidden = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
  const initSpot = (section) => {
    if (section.hasAttribute('data-hw-ready')) return;
    section.setAttribute('data-hw-ready', '');
    const tilt = section.querySelector('[data-hw-tilt]');
    const card = tilt && tilt.querySelector('.hw-spot__card');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (card && !reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      tilt.addEventListener('pointermove', (e) => {
        const r = tilt.getBoundingClientRect();
        const nx = (e.clientX - r.left) / r.width - 0.5;
        const ny = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--hw-ty', `${(nx * 14).toFixed(2)}deg`);
        card.style.setProperty('--hw-tx', `${(-ny * 12).toFixed(2)}deg`);
        card.style.setProperty('--hw-glare', '1');
        card.style.setProperty('--hw-glare-x', `${(nx * 60).toFixed(0)}%`);
      }, { passive: true });
      tilt.addEventListener('pointerleave', () => {
        card.style.setProperty('--hw-ty', '0deg');
        card.style.setProperty('--hw-tx', '0deg');
        card.style.setProperty('--hw-glare', '0');
      }, { passive: true });
    }

    const main = section.querySelector('[data-hw-spot-main] img');
    const mainWrap = section.querySelector('[data-hw-spot-main]');
    const art = section.querySelector('[data-hw-spot-art]');
    section.querySelectorAll('[data-hw-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        section.querySelectorAll('[data-hw-thumb]').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (thumb.dataset.mode === 'art') {
          art?.classList.add('is-current');
          mainWrap?.classList.remove('is-current');
          return;
        }
        art?.classList.remove('is-current');
        mainWrap?.classList.add('is-current');
        if (!main) return;
        main.classList.add('is-swapping');
        const next = new Image();
        next.onload = () => {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = thumb.dataset.src;
          requestAnimationFrame(() => main.classList.remove('is-swapping'));
        };
        next.src = thumb.dataset.src;
      });
    });

    const qtyInput = section.querySelector('.hw-spot__qty-input');
    section.querySelectorAll('[data-hw-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.hwQty, 10));
        qtyInput.value = next;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    const variantInput = section.querySelector('[data-hw-variant-input]');
    const atcPrice = section.querySelector('[data-hw-atc-price]');
    const atcButton = section.querySelector('.hw-spot__atc');
    const planInput = section.querySelector('[data-hw-plan-input]');
    const syncOffer = (radio) => {
      if (!radio) return;
      if (variantInput) variantInput.value = radio.value;
      if (planInput) {
        const plan = radio.dataset.plan || '';
        planInput.value = plan;
        planInput.disabled = !plan;
      }
      if (atcPrice) atcPrice.textContent = radio.dataset.price || '';
      if (atcButton) atcButton.disabled = radio.dataset.available !== 'true';
    };
    const offers = section.querySelectorAll('[data-hw-offer]');
    offers.forEach((radio) => radio.addEventListener('change', () => syncOffer(radio)));
    const checked = section.querySelector('[data-hw-offer]:checked');
    if (checked) syncOffer(checked);
  };
  const scan = () => document.querySelectorAll('[data-hw-spotlight]').forEach(initSpot);
  scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (section.hasAttribute('data-hw-ready')) return;
      section.setAttribute('data-hw-ready', '');
      const track = section.querySelector('[data-hw-track]');
      if (!track) return;
      const step = () => {
        const card = track.querySelector('.hw-rev__card');
        return card ? card.getBoundingClientRect().width + 20 : 320;
      };
      section.querySelector('[data-hw-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      section.querySelector('[data-hw-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    };
    const scan = () => document.querySelectorAll('[data-hw-reviews]').forEach(init);
    scan();
    document.addEventListener('shopify:section:load', scan);
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (bar) => {
      if (bar.hasAttribute('data-hw-ready')) return;
      bar.setAttribute('data-hw-ready', '');
      const after = parseInt(bar.dataset.hwStickyAfter, 10) || 600;
      const shop = document.getElementById('hw-shop');
      const update = () => {
        let show = window.scrollY > after;
        if (shop) {
          const r = shop.getBoundingClientRect();
          const inView = r.top < window.innerHeight * 0.6 && r.bottom > window.innerHeight * 0.4;
          if (inView) show = false;
        }
        const nearBottom = window.innerHeight + window.scrollY > document.body.scrollHeight - 200;
        if (nearBottom) show = false;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      window.addEventListener('scroll', update, { passive: true });
      update();
    };
    const scan = () => document.querySelectorAll('[data-hw-sticky]').forEach(init);
    scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
